var HAS_BACKGROUND = /(^|\s)bg-/;
export var cardSuppliesBackground = function (className) {
    return !HAS_BACKGROUND.test(className !== null && className !== void 0 ? className : '');
};
export var getCardStyles = function (borderRadius, shadowSize, withDefaultBackground) {
    if (withDefaultBackground === void 0) { withDefaultBackground = true; }
    return "rounded-".concat(borderRadius, " shadow-").concat(shadowSize).concat(withDefaultBackground ? ' bg-white' : '');
};
//# sourceMappingURL=card.styles.js.map